// src/components/User/DeveloperDetail.jsx
import React, { useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import AOS from 'aos';
import 'aos/dist/aos.css';

import { AppContext } from './AppContext';
import ProjectCards from './ProjectCards';

import Header from './Header';
import Footer from './Footer';

export default function DeveloperDetail() {
    const { slug } = useParams();
    const { projectHighlights, developersData } = useContext(AppContext);

    // Find the developer by slug
    const developer = developersData?.developers.find(d => d.slug === slug);

    // All highlights array
    const allHighlights = projectHighlights?.projectHighlights || [];

    // Filtered lists
    const residentialItems = allHighlights.filter(
        item => item.project_type === 'Residential' && item.developer === slug
    );
    const commercialItems = allHighlights.filter(
        item => item.project_type === 'Commercial' && item.developer === slug
    );

    useEffect(() => {
        AOS.init({ once: true });
    }, []);

    if (!developer) {
        return <p className="p-8 text-center">Developer not found.</p>;
    }

    const { name, logo, description } = developer;

    return (
        <>
            <Helmet>
                <title>{name} | PropXplorer</title>
                <meta
                    name="description"
                    content={`Explore Residential and Commercial projects by ${name} on PropXplorer.`}
                />
            </Helmet>

            <Header />

            {/* Developer Info */}
            <div
                className="developer-info bg-white p-4 md:p-8 lg:p-12 lg:px-20 flex flex-col md:flex-row items-center gap-6"
                data-aos="fade-up"
            >
                {logo && (
                    <div className="w-32 flex-shrink-0">
                        <img src={logo} alt={name} className="w-full object-contain" />
                    </div>
                )}
                <div>
                    <h2 className="text-3xl font-semibold text-gray-800 mb-4">{name}</h2>
                    <p className="text-md text-gray-600 text-justify">{description}</p>
                </div>
            </div>

            {/* Residential Projects */}
            {residentialItems.length > 0 && (
                <div
                    className="developer-residential bg-[#f5f3f1] p-4 md:p-8 lg:p-12"
                    data-aos="fade-up"
                >
                    <h2 className="text-2xl font-bold text-gray-800 mb-8 text-center">
                        Residential Projects by {name}
                    </h2>
                    <ProjectCards projectType="Residential" developerSlug={slug} />
                </div>
            )}

            {/* Commercial Projects */}
            {commercialItems.length > 0 && (
                <div
                    className="developer-commercial bg-[#e8f7f0] p-4 md:p-8 lg:p-12"
                    data-aos="fade-up"
                >
                    <h2 className="text-2xl font-bold text-gray-800 mb-8 text-center">
                        Commercial Projects by {name}
                    </h2>
                    <ProjectCards projectType="Commercial" developerSlug={slug} />
                </div>
            )}
            <Footer />
        </>
    );
}
